import {fetchFromApiRoute} from '#/utils/fetch-utils';
import {ApiUserFeedback, apiUserFeedback} from '@shareland/shareland-common';

type GeneralCreate = ApiUserFeedback['generalCreate'];
const generalCreate = async (params: GeneralCreate['reqBody']): Promise<GeneralCreate['resBody']['data']> => {
  const res = await fetchFromApiRoute<GeneralCreate>(apiUserFeedback.endpoints.generalCreate, {
    paramsDictionary: null,
    reqBody: params,
    reqQuery: {},
  });

  return res ?? null;
};

type UnlistedLandCreate = ApiUserFeedback['unlistedLandCreate'];
const unlistedLandCreate = async (
  params: UnlistedLandCreate['reqBody'],
): Promise<UnlistedLandCreate['resBody']['data']> => {
  const res = await fetchFromApiRoute<UnlistedLandCreate>(apiUserFeedback.endpoints.unlistedLandCreate, {
    paramsDictionary: null,
    reqBody: params,
    reqQuery: {},
  });

  return res ?? null;
};

export const userFeedbackRequests = {
  generalCreate,
  unlistedLandCreate,
};
